import { mainRequests } from './custom'
import { getToken } from '../utils/auth'
import axios from 'axios'
const MAIN_PATH = process.env.VUE_APP_MANAGE_BASE
const MANAGE_API = process.env.VUE_APP_MANAGE_API

export default {
  getSettlements (payload) {
    return new Promise(async (resolve, reject) => {
      const requestOptions = {
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${await getToken()}`
        }
      }
      axios.post(
        `${MANAGE_API}/psettlement/getSettlements`,
        payload,
        requestOptions
      )
        .then(data => {
          resolve(data)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  getSettlementDayData (payload) {
    return new Promise(async (resolve, reject) => {
      const requestOptions = {
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${await getToken()}`
        }
      }
      axios.post(
        `${MANAGE_API}/psettlement/getSettlementDayData`,
        payload,
        requestOptions
      )
        .then(data => {
          resolve(data)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  getSettlementDayOrderData  (payload) {
    return new Promise(async (resolve, reject) => {
      const requestOptions = {
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${await getToken()}`
        }
      }
      axios.post(
        `${MANAGE_API}/psettlement/getSettlementDayOrderData`,
        payload,
        requestOptions
      )
        .then(data => {
          resolve(data)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  getSettlementsForAccountant (payload) {
    return new Promise(async (resolve, reject) => {
      const requestOptions = {
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${await getToken()}`
        }
      }
      axios.post(
        `${MAIN_PATH}/outlet/getSettlementsForAccountant`,
        payload,
        requestOptions
      )
        .then(data => {
          resolve(data)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  downloadSettlement (payload) {
    return new Promise(async (resolve, reject) => {
      const requestOptions = {
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${await getToken()}`
        }
      }
      // TODO: fix download error
      axios.post(
        `${MANAGE_API}/psettlement/downloadSettlement`, payload, requestOptions)
        .then(data => {
          resolve(data)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  getDriverNames () {
    return new Promise(async (resolve, reject) => {
      const requestOptions = {
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${await getToken()}`
        }
      }
      axios.get(
        `${MANAGE_API}/dsettlement/getDriversNames`,
        requestOptions
      )
        .then(data => {
          resolve(data.data)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  getDSettlementsNew (payload) {
    return new Promise(async (resolve, reject) => {
      const requestOptions = {
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${await getToken()}`
        }
      }
      axios.post(
        `${MANAGE_API}/dsettlement/getDSettlements`,
        payload,
        requestOptions
      )
        .then(data => {
          resolve(data.data)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  getDSettlementsDayData (payload) {
    return new Promise(async (resolve, reject) => {
      const requestOptions = {
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${await getToken()}`
        }
      }
      axios.post(
        `${MANAGE_API}/dsettlement/getDSettlementsDayData`,
        payload,
        requestOptions
      )
        .then(data => {
          resolve(data.data)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  getDSettlementsDayOrderData (payload) {
    return new Promise(async (resolve, reject) => {
      const requestOptions = {
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${await getToken()}`
        }
      }
      axios.post(
        `${MANAGE_API}/dsettlement/getDSettlementsDayOrderData`,
        payload,
        requestOptions
      )
        .then(data => {
          resolve(data.data)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  changeSettlementStatusDriver (payload) {
    return new Promise(async (resolve, reject) => {
      const requestOptions = {
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${await getToken()}`
        }
      }
      axios.post(`${MANAGE_API}/dsettlement/changeSettlementStatus`, payload, requestOptions)
        .then(data => {
          resolve(data.data)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  saveDifference (payload) {
    return new Promise(async (resolve, reject) => {
      const requestOptions = {
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${await getToken()}`
        }
      }
      axios.post(`${MAIN_PATH}/outlet/orderSettleVariance`, payload, requestOptions)
        .then(data => {
          resolve(data)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  changeSettlementStatus (payload) {
    return new Promise(async (resolve, reject) => {
      const requestOptions = {
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${await getToken()}`
        }
      }
      axios.post(`${MAIN_PATH}/outlet/changeSettlementStatus`, payload, requestOptions)
        .then(data => {
          resolve(data)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  getAllOutletName () {
    return new Promise(async (resolve, reject) => {
      const requestOptions = {
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${await getToken()}`
        }
      }
      axios.get(
        `${MANAGE_API}/psettlement/getAllOutletName`, requestOptions)
        .then(data => {
          resolve(data)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  disableMultipleWithdrawStatus (payload) {
    return new Promise(async (resolve, reject) => {
      const requestOptions = {
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${await getToken()}`
        }
      }
      axios.post(
        `${MANAGE_API}/psettlement/disableMultipleWithdrawStatus`, payload, requestOptions)
        .then(data => {
          resolve(data)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  disableWithdrawStatus (payload) {
    return new Promise(async (resolve, reject) => {
      const requestOptions = {
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${await getToken()}`
        }
      }
      axios.post(
        `${MANAGE_API}/psettlement/disableWithdrawStatus`, payload, requestOptions)
        .then(data => {
          resolve(data)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  acceptSettlement (payload) {
    return new Promise(async (resolve, reject) => {
      const requestOptions = {
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${await getToken()}`
        }
      }
      axios.post(
        `${MANAGE_API}/psettlement/acceptSettlement`, payload, requestOptions)
        .then(data => {
          resolve(data)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  updateWithdrawPromisedTime (payload) {
    return new Promise(async (resolve, reject) => {
      const requestOptions = {
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${await getToken()}`
        }
      }
      axios.post(
        `${MANAGE_API}/psettlement/updateWithdrawPromisedTime`, payload, requestOptions)
        .then(data => {
          resolve(data)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  enableMultipleWithdrawStatus (payload) {
    return new Promise(async (resolve, reject) => {
      const requestOptions = {
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${await getToken()}`
        }
      }
      axios.post(
        `${MANAGE_API}/psettlement/enableMultipleWithdrawStatus`, payload, requestOptions)
        .then(data => {
          resolve(data)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  getOutletSettlementAct (payload) {
    const { id, year, season } = payload
    return new Promise(async (resolve, reject) => {
      const requestOptions = {
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${await getToken()}`
        }
      }
      axios.get(
        `${MANAGE_API}/psettlement/act?outlet_id=${id}&year=${year}&season=${season}`, requestOptions)
        .then(data => {
          resolve(data)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  emailRecoveryOutlet (payload) {
    const { id, outletId } = payload
    return new Promise(async (resolve, reject) => {
      const requestOptions = {
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${await getToken()}`
        }
      }
      axios.get(
        `${MANAGE_API}/psettlement/emailRecovery/${id}?outlet_id=${outletId}`, requestOptions)
        .then(data => {
          resolve(data)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  getPartnerSettlementDescription (payload) {
    return new Promise(async (resolve, reject) => {
      const requestOptions = {
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${await getToken()}`
        }
      }
      axios.get(
        `${MANAGE_API}/psettlement/getPartnerSettlementDescription`, payload, requestOptions)
        .then(data => {
          resolve(data)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  postDriverDownloadSettLement (payload) {
    return new Promise(async (resolve, reject) => {
      const requestOptions = {
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${await getToken()}`
        }
      }
      axios.post(
        `${MANAGE_API}/dsettlement/downloadSettlement`, payload, requestOptions)
        .then(data => {
          resolve(data.data)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  async getCampaigns (searchText) {
    try {
      const token = `Bearer ${await getToken()}`
      const res = await axios.get(
        'https://rest.toktok.mn/crm/campaign/?status=active&search_text=' + searchText + '&size=1000&from=0',
        {
          headers: {
            Authorization: `Bearer ${token}`
          }
        }
      )
      if (res?.status === 200 && res?.data) {
        return res.data
      }
    } catch (err) {
      throw new Error(err)
    }
  },
  getDiscounts (query) {
    return new Promise(function (resolve, reject) {
      mainRequests
        .getDiscount('/discount' + query)
        .then((res) => {
          resolve(res)
        })
        .catch((err) => {
          reject(err)
        })
    })
  },
  getBrands (query) {
    return new Promise(function (resolve, reject) {
      mainRequests
        .getAllMall('/getBrands?' + query)
        .then((res) => {
          resolve(res)
        })
        .catch((err) => {
          reject(err)
        })
    })
  },
  getSuppliers (query) {
    return new Promise(function (resolve, reject) {
      mainRequests
        .getAllMall('/getSuppliers' + query)
        .then((res) => {
          resolve(res)
        })
        .catch((err) => {
          reject(err)
        })
    })
  },
  getProducts (query) {
    return new Promise(function (resolve, reject) {
      mainRequests
        .getAllMall('/getProducts' + query)
        .then((res) => {
          resolve(res)
        })
        .catch((err) => {
          reject(err)
        })
    })
  },
  getCategories () {
    return new Promise(function (resolve, reject) {
      mainRequests
        .getAllMall('/getCategories')
        .then((res) => {
          resolve(res)
        })
        .catch((err) => {
          reject(err)
        })
    })
  },
  getServices () {
    return new Promise(function (resolve, reject) {
      mainRequests
        .getServices('/getServices')
        .then((res) => {
          resolve(res)
        })
        .catch((err) => {
          reject(err)
        })
    })
  },
  deleteDiscount (id) {
    return new Promise(function (resolve, reject) {
      mainRequests
        .delDiscount('/discount' + '/' + id)
        .then((res) => {
          resolve(res)
        })
        .catch((err) => {
          reject(err)
        })
    })
  },
  addDiscount (body) {
    return new Promise(function (resolve, reject) {
      mainRequests
        .postDiscount('/discount', body)
        .then((res) => {
          resolve(res)
        })
        .catch((err) => {
          reject(err)
        })
    })
  },
  getOneDiscount (id) {
    return new Promise(function (resolve, reject) {
      mainRequests
        .getDiscount('/discount' + '/' + id)
        .then((res) => {
          resolve(res)
        })
        .catch((err) => {
          reject(err)
        })
    })
  },
  getSuppliersApp (query) {
    return new Promise(function (resolve, reject) {
      mainRequests
        .getAllApp('/toktok/getPartners?search_text=' + query)
        .then((res) => {
          resolve(res)
        })
        .catch((err) => {
          reject(err)
        })
    })
  },
  getProductsApp (query) {
    return new Promise(function (resolve, reject) {
      mainRequests
        .getAllApp('/toktok/getProducts?search_text=' + query)
        .then((res) => {
          resolve(res)
        })
        .catch((err) => {
          reject(err)
        })
    })
  },
  getServicesApp (query) {
    return new Promise(function (resolve, reject) {
      mainRequests
        .getAllApp('/toktok/getServices?search_text=' + query)
        .then((res) => {
          resolve(res)
        })
        .catch((err) => {
          reject(err)
        })
    })
  },
  getDashboard (payload) {
    return new Promise(async (resolve, reject) => {
      const requestOptions = {
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${await getToken()}`
        }
      }
      axios.post(
        `${MANAGE_API}/psettlement/getSettlementDashboard`, payload, requestOptions)
        .then(data => {
          resolve(data)
        })
        .catch(error => {
          reject(error)
        })
    })
  }

}
